import React, { useState, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {ISimilarProps} from './types';
import * as S from './styles';
import C from '@assets/themes/colors';
import { Context } from "routes/private/Editor/Context";
import actions from '@state/actions';
import { IBrandImage, IBrandImagesOem } from '@state/brandsImages/types';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import { storageAccountName, containerNameBrands, containerName } from '@storage/azure-storage-blob';
import Loading from '@components/Loading';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import Swipeable from '@components/Swipeable';
import Button from '@components/Button';
import  { ViewAllIcon }  from '@assets/icons/viewAllIcon';
import { LeftArrowIcon } from '@assets/icons/leftArrow';
import { set } from 'lodash';

const uuid = require('react-uuid');

const SimilarBackgrounds:React.FC<ISimilarProps> = (props) => {
  const authContext = useContext(AuthContext);
  let context = useContext(Context);

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [selectedIndex, setSelectedIndex] = useState<number | undefined>(undefined);  
  const [selectedImage, setSelectedImage] = useState<IBrandImage | undefined>(undefined);  
  const [imagesOem, setImagesOem] = useState<IBrandImagesOem[]>([]);  
  const [brandImagesOem, setBrandImagesOem] = useState<IBrandImagesOem|undefined>(undefined);
  const [viewAll, setViewAll] = useState(false);  
  const [images, setImages] = useState<IBrandImage[]>([]);  
  const [viewImages, setViewImages] = useState<IBrandImage[]>([]);  

 
  const [page, setPage] = useState<number>(0);
  const pageSize =15;
  const itemsLength = 5;
  const urlBrand =`https://${storageAccountName}.blob.core.windows.net/${containerNameBrands}`;
  const urlFiles = `https://${storageAccountName}.blob.core.windows.net/${containerName}`
   let { editorStatus, data,selectDescribe, onCommandChange} = useContext(Context);

   const [metadataBack, setMetadataBack] = useState<string|undefined>(undefined);  
   const [metadataNext, setMetadataNext] = useState<string|undefined>(undefined);  

  const dispatch = useDispatch();
    
    const cleanStates=()=>
    {
        setIsLoading(false)
        setImagesOem([])                
    }


   
    useEffect(() => {    
        
        cleanStates();      
                                  
        if (props.attributes)
        {          
            if (props.attributes.brandData && props.oem)
            {              

              let image : IBrandImagesOem = {
                id:props.attributes.brandId??"",
                name:"",                
                metadata:JSON.stringify(props.attributes.brandData),
                lastlevel:true,
                images:[]
              }
              setViewAll(true)
              setBrandImagesOem(image);    
              setMetadataBack(`[${JSON.stringify(props.attributes.brandData[0])}]`);      
              setMetadataNext(JSON.stringify(props.attributes.brandData));                    
              getImages(image,0);
            }
            else
            {              
              getImagesOem("");        
            }
        }                
    }, [props.attributes]);



    async function getImagesOem(metadata:string){      
      setIsLoading(true)      
      const data: any = await fetchImagesOem(metadata)               
      if (data) setImagesOem(data);  
    }

    async function getImages(brandImagesOem:IBrandImagesOem, start:number){      
      setIsLoading(true)       
      //const data: any = await fetchImages(brandImagesOem.id,brandImagesOem.itype??"",start,pageSize)         
      const data: any = await fetchImages(brandImagesOem.id,brandImagesOem.metadata??"",start,pageSize)         
      if (data) setImages(data);   
      
    }

    useEffect(() => {                  
      if (images.length>0 )
      {                       
        let newarray = [...viewImages, ...images];            
        setViewImages(newarray);
      }
      
    },[images])

 



    const fetchImagesOem = (metadata:string) => {    
      setIsLoading(true)    
      return new Promise((resolve, reject) => {      
        dispatch(actions.brandsImages.fetchBrandsImagesOem(props.oem,"BACKGROUNDS",metadata, (result, error) => {                
          setIsLoading(false)        
          if (error) reject(error)
          else {                 
            resolve(result)}
  
        }))
      });
    }
    const fetchImages = (brandId:string, metadata:string, start:number, length:number) => {    
      setIsLoading(true)    
      let query = `c.imageType='BACKGROUNDS' and c.status='ACTIVE'`;      
      if (brandId!="" && brandId!= undefined) query += ` and c.brandId='${brandId}'`;

      if (metadata!="" && metadata != undefined)
      { 
        
          let metatypes = JSON.parse(metadata)
          metatypes.map((data: any, index: number) => {            
            query+= ` and c.types[${index}] = ${JSON.stringify(data)}`
          });
      }

      //if (type!="" && type != undefined) query+= ` and c.types[0] = { 'id': 'type','value': '${type}'}`
      return new Promise((resolve, reject) => {      
        dispatch(actions.brandsImages.fetchBrandImages(query, start,length, undefined, (result, error) => {                
          setIsLoading(false)        
          if (error) reject(error)
          else {                      
            resolve(result)}
  
        }))
      });
    }



  const getImageSrc = (data:IBrandImage)=>{
    
    if (data.id=="" || data.id== undefined)
      return data.srcImage;
    else
    {      
      return `${urlBrand}/${data.brandId}/${data.imageType?data.imageType.toLowerCase():""}/${data.srcImage}` + "TN";
    }
  }


  const renderLoaderContainer = () => {
    if (isLoading)
      return(
        <S.LoaderContainer>
          <Loading 
            id={"loading-designs"}
            containerStyle={{justifyContent: 'center'}}
          />
        </S.LoaderContainer>
      );
  }


  const handleViewAll = (image:IBrandImagesOem) => {

    if (image.lastlevel)
    {
      setViewAll(true)
      setBrandImagesOem(image);    
      getImages(image,0);
    }
    else
    {
      cleanStates();      
      getImagesOem(image.metadata??"");        
    }
    navigateNext(image.metadata??"")
  }

  const handleScroll = async(e: any) => {
    
    const bottom = e.target.scrollHeight - e.target.scrollTop === e.target.clientHeight;
    
      if (bottom)
      {
        if (brandImagesOem)
        {
          getImages(brandImagesOem, (page + pageSize));         
          setPage(page+pageSize); 
        }
        
      }
  }

  function getBackName() {        
    if ((metadataBack??"")!="")
    {
      let metaBack = JSON.parse(metadataBack??"")
      if (metaBack && metaBack.length>0)
        return metaBack[0].value;    
    }
    if (props.oem)
      return "Types";
    else
      return "Oems"
  }

  const navigateNext=(metadata:string)=>{    
    setMetadataBack(metadataNext);      
    setMetadataNext(metadata) 
  }

  const navigateBack=(metadata:string)=>{
    setMetadataBack(metadata);      
    setMetadataNext(metadataBack) 
  }

  function getViewAllName(){

    let name = 'All '
      if (brandImagesOem && brandImagesOem.metadata)
      {
        let metadata = JSON.parse(brandImagesOem.metadata)
        name += metadata[metadata.length-1].value;      
      }
      else if (brandImagesOem && brandImagesOem.name!="")
        name += brandImagesOem.name;
      name += ' Backgrounds Images'
      return name;
  }



  return (
    <>
                        
        {
          viewAll?
          <S.ViewAllContainer>
            <S.ViewAll   onClick={(e?:any)=>{         
                    setViewImages([]);
                    setImages([])                    
                    setPage(0); 
                    setViewAll(false);                    
                    navigateBack("");
                    if (imagesOem.length==0)
                      getImagesOem(metadataBack??"");    
                  }}>
              <LeftArrowIcon></LeftArrowIcon>
              <S.ViewAllText>{getBackName()}</S.ViewAllText>
            </S.ViewAll>
            <S.LogoTitle>{getViewAllName()}</S.LogoTitle>
            <S.LogosContainer onScroll={handleScroll}>
            <S.LogosWrap flex={true}>
            <TransitionGroup className="group-list" id="design-list">
                  {
                    viewImages && viewImages.length > 0 &&
                    viewImages.map((data: any, index: number) => {
                      return (
                        <CSSTransition key={index} timeout={600} classNames="item">
                          <div>
                            <S.LogoContainer selected={data.id== selectedImage?.id}>
                              <S.ImgContainer height={86} src={getImageSrc(data)} onClick={()=>{setSelectedImage(data); props.onSelect(data)}}  transparent={true}/>                              
                            </S.LogoContainer>
                          
                          </div>
                        </CSSTransition>
                      )
                    })
                  }
                </TransitionGroup>              
            </S.LogosWrap>
            </S.LogosContainer>
          </S.ViewAllContainer>
          :
          (imagesOem && imagesOem.length > 0) || isLoading ?          
          <S.SlidersContainer>
            {
              (metadataNext??"")!= "" &&
              <S.ViewAll  onClick={(e?:any)=>{                               
                      cleanStates();      
                      navigateBack(metadataBack??"")
                      getImagesOem(metadataBack??"");             
                    }}>
                <LeftArrowIcon></LeftArrowIcon>
                <S.ViewAllText>{getBackName()}</S.ViewAllText>
              </S.ViewAll>
            }
            {
              imagesOem.map((imgOem:any, i:number) =>{
                return(
                  <>
                <S.LogoTitleContainer>
                  <S.LogoTitle>{imgOem.itype?imgOem.itype:imgOem.name}</S.LogoTitle>
                  {
                    //logo.images.length>3 &&
                    <S.ViewAll  
                    style={{
                      marginLeft:`auto`,
                      marginRight:`8px`,
                      marginBottom:`3px`
                    }}
                     onClick={(e?:any)=>{                    
                      handleViewAll(imgOem);    
                    }}>
                      
                      <S.ViewAllText>VIEW ALL</S.ViewAllText>
                  </S.ViewAll>
          
                  }
                </S.LogoTitleContainer>
                <S.SwipeableContainer>
                <Swipeable
                  itemsLength={itemsLength}
                  itemWidth={90}
                  topArrows={30}                 
                  itemsCount={imgOem.images.length}   
                  itemsShow={2}
                  id={`logos${i}`}
                >
                  <TransitionGroup className="group-list">
                    { imgOem.images.map((data: any, index: number) => {
                        return (
                          <CSSTransition key={data.id} timeout={600} classNames="item">
                            <S.ItemContainer 
                            id={`preview-component-${index}-logos${i}`}
                            selected={data.id== selectedImage?.id}
                            >
                              <S.ImgContainer height={86} src={getImageSrc(data)} onClick={()=>{setSelectedImage(data); props.onSelect(data)}}  transparent={true}/>                                                              
                            </S.ItemContainer>
                          </CSSTransition>
                        )
                      })
                    }
                    {
                      imgOem.images.length>=itemsLength &&
                      <S.ViewAll onClick={(e?:any)=>{                    
                        handleViewAll(imgOem);    
                      }}>
                          <ViewAllIcon></ViewAllIcon>
                      </S.ViewAll>
                      
                    }
                  </TransitionGroup>
                </Swipeable>
                </S.SwipeableContainer>
                </>
                )
            })
            }
          {
            renderLoaderContainer()
          }

          </S.SlidersContainer>
          
          :
          <S.EmptyContainer>
          <p >There are no similar images available for this logo.</p>               
          <p>Search for vehicle images in the Brand Library by clicking the button above and providing the year, make, model, and trim that you're looking for</p>
          </S.EmptyContainer>
        }
        
        </>
  );
}

export default SimilarBackgrounds